import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  tooltipWrap: {
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },
}));
